/**
 * ============================================================================
 * 页脚内容 - Footer Content
 * ============================================================================
 *
 * 【作用】控制首页底部页脚版权/署名一行文字（中/英）。
 * 【如何修改】修改 rights 的 en / cn 字符串即可。
 */

export const footerContent = {
  rights: { en: "© 2026 Organic Quantum Materials Lab (Q-Lab).", cn: "© 2026 有机量子材料实验室 (Q-Lab)" }
};
